<template>

<nav class="navbar is-info" role="navigation" aria-label="main navigation">
  <div class="navbar-brand">
    <a class="navbar-item">
        <a href="https://www.studentqr.com" target="_blank"><img src="@/assets/img/logo2.png"  width="112" /></a>
      <!-- <img src="https://bulma.io/images/bulma-logo.png" width="112" height="28"> -->
    </a>

    <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  </div>

  <div id="navbarBasicExample" class="navbar-menu">
    <div class="navbar-start">

      <div class="navbar-item has-dropdown is-hoverable">
        <a class="navbar-link" v-bind:class="isChildActive('Dashboard')">
          <span class="icon navbar-icon"><i class="fa fa-home"></i></span>Dashboard
        </a>

        <div class="navbar-dropdown">
          <a class="navbar-item" v-on:click="goDashboard()" v-bind:class="isActive('Dashboard')">
            Main Dashboard
          </a>
          <a class="navbar-item" v-on:click="goClassDashboard()" v-bind:class="isActive('ClassDashboard')">
            Class Dashboard
          </a>
          <a class="navbar-item" v-on:click="goGroupDashboard()" v-bind:class="isActive('GroupDashboard')">
            Group Dashboard
          </a>
        </div>
      </div>

      <!-- <a class="navbar-item" v-on:click="goDashboard()" v-bind:class="isActive('Dashboard')">
        <span class="icon navbar-icon"><i class="fa fa-home"></i></span> Dashboard
      </a>
      <a class="navbar-item" v-on:click="goClassDashboard()" v-bind:class="isActive('ClassDashboard')">
        <font-awesome-icon icon="user-friends" class="icon navbar-icon" /> Class Dashboard
      </a>
      <a class="navbar-item" v-on:click="goGroupDashboard()" v-bind:class="isActive('GroupDashboard')">
        <font-awesome-icon icon="users" class="icon navbar-icon" /> Group Dashboard
      </a> -->
      <a class="navbar-item" v-on:click="goLeaderboard()" v-bind:class="isActive('Leaderboard')">
        <span class="icon navbar-icon"><i class="fa fa-trophy"></i></span> Leaderboard
      </a>
      <!-- <a class="navbar-item" v-on:click="goStaffAttendance()" v-bind:class="isActive('StaffAttendanceMain')">
        <font-awesome-icon icon="user-check" class="icon navbar-icon" /> Staff Attendance
      </a> -->
      <a class="navbar-item" v-on:click="goNotifications()" v-bind:class="isActive('Notifications')">
        <font-awesome-icon icon="bell" class="icon navbar-icon" /> Notifications
      </a>

      <div class="navbar-item has-dropdown is-hoverable">
        <a class="navbar-link" v-bind:class="isChildActive('Database')">
          <span class="icon navbar-icon"><i class="fa fa-table"></i></span>Database
        </a>

        <div class="navbar-dropdown">
          <a class="navbar-item" v-on:click="goDbStaff()" v-bind:class="isActive('DbStaffMain')">
            Teachers/Staff
          </a>
          <a class="navbar-item" v-on:click="goDbKelas()" v-bind:class="isActive('DbKelasMain')">
            Class
          </a>
          <a class="navbar-item" v-on:click="goDbGroup()" v-bind:class="isActive('DbGroupMain')">
            Groups
          </a>
          <a class="navbar-item" v-on:click="goDbPositiveBehaviour()" v-bind:class="isActive('PositiveBehaviourMain')">
            Positive Behaviour
          </a>
          <!-- <a class="navbar-item" v-on:click="goDbBehaviourCategory()" v-bind:class="isActive('DbBehaviourCategoryMain')">
            Behaviour Category
          </a> -->
          <!-- <a class="navbar-item" v-on:click="goDbBadges()" v-bind:class="isActive('BadgesHome')">
            Badges
          </a> -->
          <a class="navbar-item" v-on:click="goDbForms()" v-bind:class="isActive('FormsHome')">
            Forms
          </a>
          <!-- <hr class="navbar-divider">
          <a class="navbar-item">
            Report an issue
          </a> -->
        </div>
      </div>
    </div>

    <div class="navbar-end">
      <div class="navbar-item">
        <div class="buttons">
          <a class="button is-primary" v-on:click="goSettings()" v-bind:class="isActive('Settings')">
            <span class="icon navbar-icon"><i class="fa fa-wrench"></i></span> Settings
          </a>
          <!-- <a v-on:click="goSettings()" v-bind:class="isActive('Settings')">
                <span class="icon"><i class="fa fa-wrench"></i></span> Settings
            </a> -->
          <a class="button is-light" v-on:click="logout()">
            <span class="icon navbar-icon"><i class="fa fa-sign-out"></i></span> Logout
          </a>
          <!-- <a v-on:click="logout()">
                <span class="icon"><i class="fa fa-sign-out"></i></span> Logout
            </a> -->
        </div>
      </div>
    </div>
  </div>
</nav>


</template>

<script>
import "./public/style.scss";

export default {
    name: "TopMenu",
    data() {
        return {
            schoolID: '',
            logo: '',
            currentRouteName: ''
        };
    },
    created() {
        this.currentRouteName = this.$router.currentRoute.name
        this.logo = localStorage.getItem('schoolLogo')
    },
    mounted(){
        this.$root.$on('activeMenu', (item, response) => {

            var name = ""
            if ((item === "ClassDashboardSingle") || (item === "ClassPositiveHistory") || (item === "ClassPositiveDetails") || (item === "ClassManageStudents")){
                name = "ClassDashboard"
            }else if (item === "StaffAttendanceDetails"){
                name = "StaffAttendanceMain"
            }

            this.currentRouteName = name
            this.isActive(name)
        });
    },
    methods: {
        isActive(name){
          if (name == "GroupDashboard"){
            if (this.currentRouteName.substring(0,5) == "Group"){
              return 'is-active'
            }else{
              return ''
            }
          }else{
            if (this.currentRouteName == name){
                return 'is-active'
            }else{
                return ''
            }
          }
        },
        isChildActive(name){
            if (name == "Database"){
                if (this.currentRouteName.substring(0,2) == "Db"){
                    return 'is-active'
                }else{
                    return ''
                }
            }
        },
        goStaffAttendance(){
            this.$router.push({
                name: "StaffAttendanceMain"
            });
        },
        goDashboard() {
            this.$router.push({
                name: "Dashboard"
            });
        },
        goClassDashboard(){
            this.$router.push({
                name: "ClassDashboard"
            });
        },
        goGroupDashboard(){
            this.$router.push({
                name: "GroupDashboard"
            });
        },
        goLeaderboard(){
            this.$router.push({
                name: "LeaderboardV1"
            });
        },
        goDbKelas() {
            this.$router.push({
                name: "DbKelasMain"
            });
        },
        goDbGroup() {
            this.$router.push({
                name: "DbGroupMain"
            });
        },
        // goDbStudents() {
        //     this.$router.push({
        //         name: "StudentsMain"
        //     });
        // },
        goDbStaff() {
            this.$router.push({
                name: "StaffMain"
            });
        },
        goDbPositiveBehaviour() {
            this.$router.push({
                name: "PositiveBehaviourMain"
            });
        },
        goDbBehaviourCategory() {
            this.$router.push({
                name: "DbBehaviourCategoryMain"
            });
        },
        goDbBadges() {
            this.$router.push({
                name: "BadgesHome"
            });
        },
        goDbForms() {
            this.$router.push({
                name: "DbFormMain"
            });
        },
        goNotifications() {
            this.$router.push({
                name: "NotificationsHome"
            });
        },
        goSettings() {
            this.$router.push({
                name: "Settings"
            });
        },
        logout(){
            localStorage.removeItem('user')
            localStorage.removeItem('jwtToken')
            localStorage.removeItem('email')
            localStorage.removeItem('sessionID')
            localStorage.removeItem('schoolID')
            this.$emit("authenticated", false)

            this.$router.push({
                name: "Login"
            });
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/TopMenu.vue